import moment from 'moment';
import { DATE_FORMAT } from '../constants/CommonConstants';
import { setCurrentDateToLocalStorage, getCurrentDateFromLocalStorage, getCurrentPageUrl, getUrlParams, setPreviousDuration, changeDataForDay, showDayPath } from "../util/util";


function changeToDaily(that) {
    // すでに「日」表示の場合は処理をSKIP        
    if (that.state.selectedDuration !== "day") {
        let today = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        let oneBeforeDate = moment(that.state.baseDate, DATE_FORMAT).add(-1, 'day').format(DATE_FORMAT);
        let twoBeforeDate = moment(that.state.baseDate, DATE_FORMAT).add(-2, 'day').format(DATE_FORMAT);
        let baseDate = moment(that.state.baseDate, DATE_FORMAT).format(DATE_FORMAT);

        that.setState({
            baseDate: baseDate,
            oneBeforeDate: oneBeforeDate,
            twoBeforeDate: twoBeforeDate,
            threeBeforeDate: moment(that.state.baseDate, DATE_FORMAT).add(-3, 'days').format(DATE_FORMAT),
            selectedDuration: "day",
            beforeTitle: displayDate(that, today.diff(moment(twoBeforeDate, DATE_FORMAT), 'day'), 'day'),
            afterTitle: displayDate(that, today.diff(moment(oneBeforeDate, DATE_FORMAT), 'day'), 'day'),
            isInitDate: false,
        });
        changeDataForDay(baseDate, oneBeforeDate, 'day');
    }
    if (!showDayPath) {
        setPreviousDuration('day');
    }
}

function changeToWeekly(that) {
    // すでに「週」表示の場合は処理をSKIP
    if (that.state.selectedDuration !== "week") {
        // 今日を起点に、週の始まりの日曜日の日付を取得
        let thisWeek = moment().set({ day: 0, hour: 0, minute: 0, second: 0, millisecond: 0 }).startOf('week');
        let baseDate = null;
        if (that.state.selectedDuration === "day") {
            // 日→週の場合：Headerに表示していた日付を起点に、週の始まりの日曜日の日付を取得
            // baseDate = moment(that.state.oneBeforeDate).day(0).format(DATE_FORMAT)
            baseDate = moment(that.state.oneBeforeDate).day(7).format(DATE_FORMAT)
        } else {
            // 月→週の場合：Headerに表示していた最終日を起点に、週の始まりの日曜日の日付を取得
            // 月→週の場合は、その日を含む日曜～土曜を最終週として表示するため、さらに一週分追加した値をbaseDateとする
            baseDate = moment(that.state.oneBeforeDate).endOf('month').startOf('week').add(1, 'week').format(DATE_FORMAT);
        }
        let oneBeforeDate = moment(baseDate, DATE_FORMAT).add(-1, 'week').format(DATE_FORMAT);
        let twoBeforeDate = moment(baseDate, DATE_FORMAT).add(-2, 'week').format(DATE_FORMAT);
        let threeBeforeDate = moment(baseDate, DATE_FORMAT).add(-3, 'week').format(DATE_FORMAT);
        that.setState({
            baseDate: baseDate,
            oneBeforeDate: oneBeforeDate,
            twoBeforeDate: twoBeforeDate,
            threeBeforeDate: threeBeforeDate,
            selectedDuration: "week",
            beforeTitle: displayDate(that, thisWeek.diff(moment(twoBeforeDate, DATE_FORMAT), 'week'), 'week'),
            afterTitle: displayDate(that, thisWeek.diff(moment(oneBeforeDate, DATE_FORMAT), 'week'), 'week'),
            isInitDate: baseDate === moment(thisWeek).format(DATE_FORMAT),
        });
        changeDataForDay(baseDate, oneBeforeDate, 'week');
    }
    if (!showDayPath()) {
        setPreviousDuration("week");
    }
}

function changeToMonthly(that) {
    // すでに「月」表示の場合は処理をSKIP
    if (that.state.selectedDuration !== "month") {
        let thisMonth = moment().set({ day: 0, hour: 0, minute: 0, second: 0, millisecond: 0 }).startOf('month');
        // baseDateの翌月1日の日付を取得
        // Header表示の日付最終日が月末日の場合はbaseDateが次月1日を指しているため、baseDateから-1日したうえで翌月1日を取得
        let baseDate = moment(that.state.baseDate, DATE_FORMAT).add(-1, 'day').add(1, 'month').date(1).format(DATE_FORMAT);
        let oneBeforeDate = moment(baseDate, DATE_FORMAT).add(-1, 'month').format("YYYY/MM/01");
        let twoBeforeDate = moment(baseDate, DATE_FORMAT).add(-2, 'month').format(DATE_FORMAT);
        let threeBeforeDate = moment(baseDate, DATE_FORMAT).add(-3, 'month').format(DATE_FORMAT);
        that.setState({
            baseDate: baseDate,
            oneBeforeDate: oneBeforeDate,
            twoBeforeDate: twoBeforeDate,
            threeBeforeDate: threeBeforeDate,
            selectedDuration: "month",
            beforeTitle: displayDate(that, thisMonth.diff(moment(twoBeforeDate, DATE_FORMAT), 'month'), 'month'),
            afterTitle: displayDate(that, thisMonth.diff(moment(oneBeforeDate, DATE_FORMAT), 'month'), 'month'),
            isInitDate: false,
        });
        changeDataForDay(baseDate, oneBeforeDate, 'month');
    }
}

function displayDate(that, beforeDateNum, duration) {
    if (duration === 'day') {
        if (beforeDateNum === 0) {
            return that.props.intl.formatMessage({ id: "common_today" });
        } else if (beforeDateNum === 1) {
            return that.props.intl.formatMessage({ id: "common_yesterday" });
        } else if (beforeDateNum === 2) {
            return that.props.intl.formatMessage({ id: "common_2days_ago" });
        } else if (beforeDateNum === -1) {
            return that.props.intl.formatMessage({ id: "common_tomorrow" });
        } else if (beforeDateNum === -2) {
            return that.props.intl.formatMessage({ id: "common_2days_after" });
        } else if (beforeDateNum < 0) {
            return that.props.intl.formatMessage({ id: "common_days_after" }, { dateNum: Math.abs(beforeDateNum) });
        } else {
            return that.props.intl.formatMessage({ id: "common_days_ago" }, { dateNum: beforeDateNum });
        }
    } else if (duration === 'week') {
        if (beforeDateNum === 0) {
            return that.props.intl.formatMessage({ id: "common_this_week" });
        } else if (beforeDateNum === 1) {
            return that.props.intl.formatMessage({ id: "common_last_week" });
        } else if (beforeDateNum === 2) {
            return that.props.intl.formatMessage({ id: "common_2weeks_ago" });
        } else if (beforeDateNum === -1) {
            return that.props.intl.formatMessage({ id: "common_next_week" });
        } else if (beforeDateNum === -2) {
            return that.props.intl.formatMessage({ id: "common_2weeks_after" });
        } else if (beforeDateNum < 0) {
            return that.props.intl.formatMessage({ id: "common_weeks_after" }, { dateNum: Math.abs(beforeDateNum) });
        } else {
            return that.props.intl.formatMessage({ id: "common_weeks_ago" }, { dateNum: beforeDateNum });
        }
    } else if (duration === 'month') {
        if (beforeDateNum === 0) {
            return that.props.intl.formatMessage({ id: "common_this_month" });
        } else if (beforeDateNum === 1) {
            return that.props.intl.formatMessage({ id: "common_last_month" });
        } else if (beforeDateNum === 2) {
            return that.props.intl.formatMessage({ id: "common_2months_ago" });
        } else if (beforeDateNum === -1) {
            return that.props.intl.formatMessage({ id: "common_next_month" });
        } else if (beforeDateNum === -2) {
            return that.props.intl.formatMessage({ id: "common_2months_after" });
        } else if (beforeDateNum < 0) {
            return that.props.intl.formatMessage({ id: "common_months_after" }, { dateNum: Math.abs(beforeDateNum) });
        } else {
            return that.props.intl.formatMessage({ id: "common_months_ago" }, { dateNum: beforeDateNum });
        }
    } else {
        return '';
    }
}

const RefreshPage = (props) => {
    return;
};

function refreshPageDetail(startDate, endDate, that, page) {

    if (!startDate || !endDate) {
        return;
    }

    let oneBeforeDate = '';
    let twoBeforeDate = '';
    let threeBeforeDate = '';
    let thisMonth = '';
    let thisWeek = '';
    let today = '';
    let beforeTitle = '';
    let afterTitle = '';
    let localOneBeforeDate = localStorage.getItem("currentOneBeforeDate");
    let localBaseDate = localStorage.getItem("currentBaseDate");
    let isInitDate = false;
    let disabledFlag = true;
    let baseDate = '';
    let titleFlag = false;

    if (page !== 'TopOperator' && page !== 'FullScreenOutputPaperGraph' && page !== 'FullScreenAvailabilityResultsGraph' && page !== 'FullScreenInterruptionTable') {
        titleFlag = true;
    }
    
    if (that.state.selectedDuration === "day") {
        baseDate = localBaseDate;
        today = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        oneBeforeDate = moment(localOneBeforeDate, DATE_FORMAT).format(DATE_FORMAT);
        twoBeforeDate = moment(localOneBeforeDate, DATE_FORMAT).add(-1, 'day').format(DATE_FORMAT);
        threeBeforeDate = moment(oneBeforeDate, DATE_FORMAT).add(-2, 'day').format(DATE_FORMAT);

        if (titleFlag) {
            beforeTitle = displayDate(that, today.diff(moment(twoBeforeDate, DATE_FORMAT), 'day'), 'day');
            afterTitle = displayDate(that, today.diff(moment(oneBeforeDate, DATE_FORMAT), 'day'), 'day');
        }
        isInitDate = false;
        disabledFlag = true;

    } else if (that.state.selectedDuration === "week") {
        thisWeek = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).startOf('week');
        oneBeforeDate = localOneBeforeDate;
        twoBeforeDate = moment(localOneBeforeDate, DATE_FORMAT).add(-1, 'week').format(DATE_FORMAT);
        let previousBaseDate = moment(localBaseDate, DATE_FORMAT).format(DATE_FORMAT);
        baseDate = localBaseDate;
        threeBeforeDate = moment(oneBeforeDate, DATE_FORMAT).add(-2, 'week').format(DATE_FORMAT);

        if (titleFlag) {
            beforeTitle = displayDate(that, thisWeek.diff(moment(twoBeforeDate, DATE_FORMAT), 'week'), 'week');
            afterTitle = displayDate(that, thisWeek.diff(moment(oneBeforeDate, DATE_FORMAT), 'week'), 'week');
        }
        isInitDate = previousBaseDate === moment(thisWeek).format(DATE_FORMAT);
        disabledFlag = true;

    } else if (that.state.selectedDuration === "month") {
        thisMonth = moment().set({ day: 0, hour: 0, minute: 0, second: 0, millisecond: 0 }).startOf('month');
        oneBeforeDate = localOneBeforeDate;
        twoBeforeDate = moment(localOneBeforeDate, DATE_FORMAT).add(-1, 'month').format(DATE_FORMAT);
        baseDate = localBaseDate;
        threeBeforeDate = moment(localOneBeforeDate, DATE_FORMAT).add(-2, 'month').format(DATE_FORMAT);
        if (titleFlag) {
            beforeTitle = displayDate(that, thisMonth.diff(moment(twoBeforeDate, DATE_FORMAT), 'month'), 'month');
            afterTitle = displayDate(that, thisMonth.diff(moment(oneBeforeDate, DATE_FORMAT), 'month'), 'month');
        }
        isInitDate = false;
        disabledFlag = true;

    } else {
        thisWeek = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).startOf('week');
        oneBeforeDate = localOneBeforeDate;
        twoBeforeDate = moment(localOneBeforeDate, DATE_FORMAT).add(-1, 'week').format(DATE_FORMAT);
        let previousBaseDate = moment(localBaseDate, DATE_FORMAT).format(DATE_FORMAT);
        baseDate = localBaseDate;
        threeBeforeDate = moment(localOneBeforeDate, DATE_FORMAT).add(-2, 'week').format(DATE_FORMAT);
        if (titleFlag) {
            beforeTitle = displayDate(that, thisWeek.diff(moment(twoBeforeDate, DATE_FORMAT), 'week'), 'week');
            afterTitle = displayDate(that, thisWeek.diff(moment(oneBeforeDate, DATE_FORMAT), 'week'), 'week');
        }
        isInitDate = previousBaseDate === moment(thisWeek).format(DATE_FORMAT);
        disabledFlag = true;
    }
    that.setState({
        baseDate: baseDate,
        oneBeforeDate: oneBeforeDate,
        twoBeforeDate: twoBeforeDate,
        threeBeforeDate: threeBeforeDate,
        isInitDate: isInitDate,
        disabledFlag: disabledFlag
    });

    if (titleFlag) {
        that.setState({
            beforeTitle: beforeTitle,
            afterTitle: afterTitle,
        });
    }

}

function setStateBaseOnCurrentDate(that, duration) {
    let current = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    let baseDate;
    switch (duration) {
        case "day":
            baseDate = moment(getCurrentDateFromLocalStorage().baseDate).format(DATE_FORMAT);
            break;
        case "week":
            baseDate = moment(getCurrentDateFromLocalStorage().baseDate).startOf('week').format(DATE_FORMAT);
            current = current.startOf("week");
            break;
        case "month":
            baseDate = moment(moment(localStorage.currentBaseDate ? localStorage.currentBaseDate : getCurrentDateFromLocalStorage().baseDate)).startOf("month").format(DATE_FORMAT);
            current = current.startOf("month");
            break;
        default:
            break;
    }

    let oneBeforeDate = moment(baseDate, DATE_FORMAT).add(-1, duration).format(DATE_FORMAT);
    let twoBeforeDate = moment(baseDate, DATE_FORMAT).add(-2, duration).format(DATE_FORMAT);

    that.setState({
        baseDate: baseDate,
        oneBeforeDate: oneBeforeDate,
        twoBeforeDate: twoBeforeDate,
        threeBeforeDate: moment(baseDate, DATE_FORMAT).add(-3, duration).format(DATE_FORMAT),
        beforeTitle: displayDate(that, current.diff(moment(twoBeforeDate, DATE_FORMAT), duration), duration),
        afterTitle: displayDate(that, current.diff(moment(oneBeforeDate, DATE_FORMAT), duration), duration),
        selectedDuration: duration,
        isInitDate: baseDate === moment().startOf('week').format(DATE_FORMAT),
    })
    localStorage.setItem("currentOneBeforeDate", oneBeforeDate);
    localStorage.setItem("currentBaseDate", baseDate);
    if(!showDayPath()){
        localStorage.setItem("currentDuration", duration);
    }
}

export { changeToDaily, changeToWeekly, changeToMonthly, RefreshPage, refreshPageDetail, displayDate, setStateBaseOnCurrentDate };
